import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { forkJoin, Observable, switchMap } from 'rxjs';
import { DriftConfiguration } from '../models/configuration.interface';
import { ReviewSession as ReviewSession, ReviewSessionPost as ReviewSessionPost } from '../models/review.interface';
import { CollectionsLinks } from '../models/collection.interface';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = this.configurationService.getConfiguration();
  }

  createReviewSession(documentName: string, personaId: string) {
    const reviewSession: ReviewSessionPost = {
      persona_id: personaId,
      document: documentName
    };
    console.log(reviewSession);
    return this.http.post<ReviewSession>(`${this.config.driftApi}/reviews`, reviewSession);
  }

  getRecentlyReviewed(): Observable<ReviewSession[]> {
    return this.http.get<ReviewSession[]>(`${this.config.driftApi}/reviews`);
  }

  getReviewSession(review_id: string): Observable<ReviewSession> {
    return this.http.get<ReviewSession>(`${this.config.driftApi}/reviews/${review_id}`);
  }

  updateReviewSession(reviewSession: ReviewSession): Observable<ReviewSession> {
    return this.http.put<ReviewSession>(`${this.config.driftApi}/reviews/${reviewSession.review_id}`, reviewSession);
  }

  uploadFilesToReview(id: string, files: FileList): Observable<object> {
    const fileArray = Array.from(files);
    const data = { files: fileArray.map(file => file.name) };

    return this.http.post<CollectionsLinks>(`${this.config.driftApi}/reviews/${id}/links`, data).pipe(
      switchMap(response => {
        const httpSessions: Observable<object>[] = [];
        response.links.forEach(link => {
          const file = fileArray.find(f => f.name === link.file_name);
          if (file) {
            httpSessions.push(this.http.put(link.url, file, { reportProgress: true, observe: 'events' }));
          } else {
            console.error(`Upload details missing for file: ${link.file_name}`);
          }
        });
        return forkJoin(httpSessions);
      })
    );
  }
}
